"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SparklineQueryWrapper = void 0;
const tslib_1 = require("tslib");
const vizportal_webclient_api_1 = require("@tableau/vizportal-webclient-api");
const GetViewByPathMethod_1 = require("@tableau/vizportal-webclient-api/lib/api/methods/GetViewByPathMethod");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_core_1 = require("@tableau/catalog-core");
/**
 * A wrapper around the Sparkline component that makes the API query to populate its data.
 */
class SparklineQueryWrapper extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataPoints: [],
        };
    }
    sendRequest(vizPortalWebClientRequester) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const get = vizPortalWebClientRequester.createSender(GetViewByPathMethod_1.GetViewByPathMethod);
            const params = { path: this.props.viewPath };
            const resp = yield get(params);
            if (!vizportal_webclient_api_1.WebClientResponseHelper.isErrorResponse(resp)) {
                return resp.response.result;
            }
            return null;
        });
    }
    componentDidMount() {
        this
            .sendRequest(this.props.vizPortalWebClientRequester)
            .then(viewDetails => {
            const dataPointsArray = viewDetails && viewDetails.hitsTimeSeries || [];
            this.setState({
                dataPoints: dataPointsArray,
            });
        })
            .catch(err => {
            catalog_core_1.Logger.error(`getViewByPath for Sparkline did not succeed. The sparkline will be unavailable. ${String(err)}`);
        });
    }
    render() {
        return this.props.children({ dataPoints: this.state.dataPoints });
    }
}
exports.SparklineQueryWrapper = SparklineQueryWrapper;
//# sourceMappingURL=SparklineQueryWrapper.js.map